import {texture, MiniSignal} from "p3";
import common from "../common";
import { locale } from "../utils";

export default class PauseHelpPanel extends PIXI.Container {
    constructor() {
        super();

        this.signals = {};
        this.signals.resume = new MiniSignal();

        this._numHints = 2;
        this._currentHelpImageIndex = 0;
        this._paper = null;
        this._leftArm = null;
        this._leftThumb = null;
        this._rightArm = null;
        this._rightThumb = null;
        this._helpImages = [];
        this._resumeButton = null;
        this._nextButton = null;
        this._previousButton = null;
        this._hintText = [];

        if (PIXI.utils.isMobile.any) {
            this._hintTextStrings = [locale("help_3"), locale("help_4")]
        } else {
            this._hintTextStrings = [locale("help_1"), locale("help_2")]    
        }

        this.init();
    }

    init() {
        this._leftArm = new PIXI.Sprite(texture("arm_l"));
        this._leftArm.anchor.set(0.5);
        this._leftArm.x = -430;
        this._leftArm.y = 206;
        this.addChild(this._leftArm);

        this._rightArm = new PIXI.Sprite(texture("arm_l"));
        this._rightArm.anchor.set(0.5);
        this._rightArm.x = 430;
        this._rightArm.y = 206;
        this._rightArm.scale.set(-1, 1);
        this.addChild(this._rightArm);

        this._paper = new PIXI.Sprite(texture("panel_pause"));
        this._paper.anchor.set(0.5);
        this.addChild(this._paper);

        this._leftThumb = new PIXI.Sprite(texture("arm_l_thumb"));
        this._leftThumb.anchor.set(0.5);
        this._leftThumb.x = -420;
        this._leftThumb.y = 203;
        this.addChild(this._leftThumb);

        this._rightThumb = new PIXI.Sprite(texture("arm_l_thumb"));
        this._rightThumb.anchor.set(0.5);
        this._rightThumb.x = 420;
        this._rightThumb.y = 203;
        this._rightThumb.scale.set(-1, 1);
        this.addChild(this._rightThumb);

        this._nextButton = new P3.Button.create(
            texture("btn_chevron_r_out"),
            null,
            null,
            texture("btn_icon_chevron_r")
        );
        this._nextButton.overSoundName = "sfx_btn_generic_rollover";
        this._nextButton.clickSoundName = "sfx_btn_generic_press_00";
        this._nextButton.x = 350;
        this._nextButton.y = -30;
        this._nextButton.signals.click.add(() => this._nextHint(), this);
        this.addChild(this._nextButton);
        
        this._previousButton = new P3.Button.create(
            texture("btn_chevron_r_out"),
            null,
            null,
            texture("btn_icon_chevron_r")
        );
        this._previousButton.overSoundName = "sfx_btn_generic_rollover";
        this._previousButton.clickSoundName = "sfx_btn_generic_press_00";
        this._previousButton.x = -350;
        this._previousButton.y = -30;
        this._previousButton.scale.set(-1, 1);
        this._previousButton.visible = false;
        this._previousButton.signals.click.add(() => this._previousHint(), this);
        this.addChild(this._previousButton);

        this._resumeButton = new P3.Button.create(
            texture("btn_action_large_out"),
            null,
            null,
            texture("btn_icon_large_play")
        );
        this._resumeButton.overSoundName = "sfx_btn_generic_rollover";
        this._resumeButton.clickSoundName = "sfx_btn_generic_press_00";
        this._resumeButton.y = 235;
        this._resumeButton.signals.click.add(() => this.signals.resume.dispatch(), this);
        this.addChild(this._resumeButton);
        
        this._createHints();
    }

    _createHints() {
        for (let i = 0; i < this._numHints; ++i) {
            this._helpImages[i] = new PIXI.Sprite(texture("img_help_0" + (i+1)));
            this._helpImages[i].anchor.set(0.5);
            this._helpImages[i].y = -50;
            this._helpImages[i].visible = false;
            this.addChild(this._helpImages[i]);

            let platformSuffix = "";
            if (PIXI.utils.isMobile.any) { 
                platformSuffix = "_mobile";
            } else {
                platformSuffix = "_desktop";
            }

            const icon = new PIXI.Sprite(texture("img_help_0" + (i+1) + platformSuffix));
            icon.anchor.set(0.5);
            this._helpImages[i].addChild(icon);
        }

        for (let i = 0; i < this._hintTextStrings.length; ++i) {
            const hintLabel = this._hintTextStrings[i];
            this._hintText[i] = new PIXI.BitmapText(hintLabel, {
                fontName: "Alghera Pro",
                fontSize: 30,
                maxWidth: 570,
                align: "center",
                tint: 0x742814
            });
            this._hintText[i].y = 130;
            this._hintText[i].anchor.set(0.5);
            this._hintText[i].visible = false;
            this.addChild(this._hintText[i]);
        }
        
        this._hintText[this._currentHelpImageIndex].visible = true;
        this._helpImages[this._currentHelpImageIndex].visible = true;
    }    

    destroy() {
        this._nextButton && this._nextButton.destroy();
        this._previousButton && this._previousButton.destroy();
        this._resumeButton && this._resumeButton.destroy();

        super.destroy({ children: true });
    }

    update() {}

    _nextHint() {
        this._currentHelpImageIndex += 1;
        if (this._currentHelpImageIndex >= 1) {
            this._currentHelpImageIndex = 1;
        }

        this._helpImages[this._currentHelpImageIndex - 1].visible = false;
        this._helpImages[this._currentHelpImageIndex].visible = true;

        this._hintText[this._currentHelpImageIndex - 1].visible = false;
        this._hintText[this._currentHelpImageIndex].visible = true;

        if(this._currentHelpImageIndex == this._numHints-1) {
            this._nextButton.visible = false;
        }
        this._previousButton.visible = true;
    }

    _previousHint() {
        this._currentHelpImageIndex -= 1;
        if (this._currentHelpImageIndex <= 0) {
            this._currentHelpImageIndex = 0;
        }

        this._helpImages[this._currentHelpImageIndex + 1].visible = false;
        this._helpImages[this._currentHelpImageIndex].visible = true;

        this._hintText[this._currentHelpImageIndex + 1].visible = false;
        this._hintText[this._currentHelpImageIndex].visible = true;

        if(this._currentHelpImageIndex == 0) {
            this._previousButton.visible = false;
        }
        this._nextButton.visible = true;
    }
}